module.exports = __webpack_public_path__ + "static/img/2-1.cd9c222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/2-1.jpg
// module id = sGPZ
// module chunks = 1